import { axiosBaseQuery } from '../../../lib/axios'
import { createApi } from '@reduxjs/toolkit/query/react'

function normalizeDealPromoResponse(response) {
  return response?.result ?? response
}

export const dealsApi = createApi({
  reducerPath: 'dealsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['myDeals'],
  endpoints: (builder) => ({
    getBundles: builder.query({
      query: () => ({
        url: 'user/bundles',
        method: 'GET',
      }),
      transformResponse: (response) => response.bundles,
    }),

    getDefaultDeals: builder.query({
      query: (slug) => ({
        url: `user/bundles/${slug}/default/deals`,
        method: 'GET',
      }),
    }),

    getMyDeals: builder.query({
      query: (slug) => ({
        url: `user/bundles/${slug}/deals`,
        method: 'GET',
      }),
      providesTags: ['myDeals'],
    }),

    createDeal: builder.mutation({
      query: ({ slug, formValues }) => ({
        url: `user/bundles/${slug}/deals`,
        method: 'POST',
        data: formValues,
      }),
    }),

    createPaymentIntent: builder.query({
      query: ({ type, deal_id, promo_code }) => ({
        url:
          type === 'SUBSCRIPTION'
            ? `user/v2/deals/${deal_id}/payment_intent`
            : `user/deals/${deal_id}/payment_intent`,
        method: 'GET',
        params: promo_code ? { promo_code } : undefined,
      }),
    }),

    applyDealPromotionCode: builder.mutation({
      query: ({ deal_id, code }) => ({
        method: 'POST',
        url: `user/v2/deals/${deal_id}/apply-promotion-code`,
        data: { code },
        headers: { 'Content-Type': 'application/json' },
      }),
      transformResponse: normalizeDealPromoResponse,
    }),

    misapplyDealPromotionCode: builder.mutation({
      query: ({ deal_id }) => ({
        method: 'POST',
        url: `user/v2/deals/${deal_id}/misapply-promotion-code`,
        headers: { 'Content-Type': 'application/json' },
      }),
      transformResponse: normalizeDealPromoResponse,
    }),

    cancelDealSubscription: builder.mutation({
      query: (formValues) => ({
        url: `user/deals/subscription/cancel`,
        method: 'POST',
        data: formValues,
      }),
      invalidatesTags: ['myDeals'],
    }),
  }),
})

export const {
  useGetBundlesQuery,
  useGetDefaultDealsQuery,
  useGetMyDealsQuery,
  useCreateDealMutation,
  useCreatePaymentIntentQuery,
  useLazyCreatePaymentIntentQuery,
  useApplyDealPromotionCodeMutation,
  useMisapplyDealPromotionCodeMutation,
  useCancelDealSubscriptionMutation,
} = dealsApi

export const { getBundles } = dealsApi.endpoints
